/**
 * Single source for money formatting. Currency is per-client
 * (clients.currency → /auth/me → useCurrency); defaults to USD — never ILS.
 *
 * Money uses the en-US number locale (decoupled from UI_LOCALE / dates, which
 * stay en-GB) so USD renders as "$1,234" rather than en-GB's "US$1,234". The
 * currency symbol still follows the currency code (₪ for ILS, € for EUR, etc.).
 */
const MONEY_LOCALE = 'en-US';

export function formatCurrency(
  value: number | null | undefined,
  currency = 'USD',
): string {
  if (value === null || value === undefined) return '';
  return new Intl.NumberFormat(MONEY_LOCALE, {
    style: 'currency',
    currency,
    maximumFractionDigits: 0,
  }).format(value);
}

/** Just the currency symbol (for input prefixes), e.g. '$' / '₪' / '€'. */
export function currencySymbol(currency = 'USD'): string {
  return (
    new Intl.NumberFormat(MONEY_LOCALE, { style: 'currency', currency })
      .formatToParts(0)
      .find((p) => p.type === 'currency')?.value ?? currency
  );
}
